import React, {ReactNode} from 'react';
import styles from './LoadingWrapper.module.scss';

interface LoadingWrapperProps {
    loading: boolean;
    children: ReactNode;
    loadingIndicator?: ReactNode;
}

const LoadingWrapper = ({ loading, children, loadingIndicator }: LoadingWrapperProps) => {
    return (
        <>
            {loading ? (
                loadingIndicator || <DefaultLoadingIndicator />
            ) : (
                children
            )}
        </>
    );
};

const DefaultLoadingIndicator = () => (
    <div className={styles.loadingWrapper}>
        <div className={styles.spinner}></div>
        <p className={styles.loadingText}>Loading...</p>
    </div>
);

export default LoadingWrapper;
